import api from '../../../api/client';
// components/Expenses.js
import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { formatKES } from "../../../utils/currency";
import DataTable from "react-data-table-component";
import ExpensesAnalytics from "./ExpensesAnalytics";
// import e from "express";

const Expenses = ({ dateRange, fetchData }) => {
  const [expensesData, setExpensesData] = useState([]);

  useEffect(() => {
    fetchData("expenses", setExpensesData);
  }, [dateRange, fetchData]);
if (!expensesData || expensesData.length === 0) {
    return <div className="text-center py-4">No expenses data available</div>;
  }

  return (
    <div className="mt-4">
      <ExpensesAnalytics analytics={expensesData} />
    </div>
  );
};

export default Expenses;
